import { render } from "./InvoiceBody.vue?vue&type=template&id=7ad1c02c"
import script from "./InvoiceBody.vue?vue&type=script&lang=js"
export * from "./InvoiceBody.vue?vue&type=script&lang=js"

import "./InvoiceBody.vue?vue&type=style&index=0&id=7ad1c02c&lang=css"
script.render = render

export default script